// src/Pages/Admin.js
import React from "react";
import { Admin, defaultTheme, Resource } from "react-admin";
import { deepmerge } from "@mui/utils";
import AdminHeader from "./Admin/components/AdminHeader";
import AdminSidebar from "./Admin/components/AdminSidebar";
import AdminDashboard from "./Admin/components/AdminDashboard";
import AdminSettings from "./Admin/AdminSettings";
import { UserResource } from "./Admin/resources/AdminUsers";
import { SupportMessageResource } from "./Admin/resources/AdminSupportMessages";
import { combinedDataProvider } from "./Admin/core/combinedDataProvider";

// Custom theme
const myCustomTheme = deepmerge(defaultTheme, {
  palette: {
    primary: { main: "#3B82F6" },
    success: { main: "#10B981" },
    error: { main: "#DC2626" },
    warning: { main: "#F97316" },
    background: {
      default: "#F3F4F6",
      paper: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", sans-serif',
  },
});

// Custom Layout with new components
const CustomLayout = (props) => (
  <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
    <AdminHeader userName="Admin User" />
    <div style={{ display: "flex", flex: 1, overflow: "hidden" }}>
      <AdminSidebar />
      <main style={{ flex: 1, overflow: "auto" }}>{props.children}</main>
    </div>
  </div>
);

export default function AdminPanel() {
  return (
    <div style={{ width: "100%" }}>
      <Admin
        basename="/admin"
        dataProvider={combinedDataProvider}
        theme={myCustomTheme}
        layout={CustomLayout}
        dashboard={AdminDashboard}
      >
        {UserResource}
        {SupportMessageResource}

        <Resource
          name="settings"
          options={{ label: "Settings" }}
          list={AdminSettings}
        />
      </Admin>
    </div>
  );
}
